module.exports = __webpack_public_path__ + "static/media/drop-down-arrow.19e977c0.svg";